import { api } from 'shared/api'
import { ChannelApiSchemas } from 'shared/api/requests/channel/schemas'

export const ChannelApi = {
  prepareIgAccountDisable: api.account.createGet({
    url: '/channel/prepareIgAccountDisable',
    schemas: ChannelApiSchemas.prepareIgAccountDisable,
  }),
  prepareFbPageDisable: api.account.createGet({
    url: '/channel/prepareFbPageDisable',
    schemas: ChannelApiSchemas.prepareFbPageDisable,
  }),
  reconnectIgAccount: api.account.createGet({
    url: '/channel/reconnectIgAccount',
    schemas: ChannelApiSchemas.reconnectIgAccount,
  }),
  prepareTikTokAccountDisconnect: api.account.createGet({
    url: '/channel/prepareTiktokAccountDisconnect',
    schemas: ChannelApiSchemas.prepareTikTokAccountDisconnect,
  }),
  confirmTikTokAccountDisconnect: api.account.createGet({
    url: '/channel/confirmTiktokAccountDisconnect',
    schemas: ChannelApiSchemas.confirmTikTokAccountDisconnect,
  }),
  prepareInstagramAccountDisconnect: api.account.createGet({
    url: '/channel/prepareIgAccountDisconnect',
    schemas: ChannelApiSchemas.prepareInstagramAccountDisconnect,
  }),
  confirmInstagramAccountDisconnect: api.account.createGet({
    url: '/channel/confirmIgAccountDisconnect',
    schemas: ChannelApiSchemas.confirmInstagramAccountDisconnect,
  }),
  connectFBChannel: api.account.createPost({
    url: '/channel/connectFb',
    schemas: ChannelApiSchemas.connectFBChannel,
  }),
}
